import { render } from "./EventImages.vue?vue&type=template&id=ff5f8350&scoped=true"
import script from "./EventImages.vue?vue&type=script&lang=js"
export * from "./EventImages.vue?vue&type=script&lang=js"

import "./EventImages.vue?vue&type=style&index=0&id=ff5f8350&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff5f8350"]])

export default __exports__